module.exports = __webpack_public_path__ + "img/index_advantage_icon_four@2x.3484b562.png";